import * as qs from 'qs';
import Http from '../../common/services/Http';
import { DashboardSearchCriteria } from './criterias/DashboardSearchCriteria';
import { ConsumesDashboardDto } from './dtos/ConsumesDashboardDto';
import { CountersDashboardDto } from './dtos/CountersDashboardDto';
import DashboardDto from './dtos/DashboardDto';
import { ExpensesDashboardDto } from './dtos/ExpensesDashboardDto';
import { MonthlyCostDashboardDto } from './dtos/MonthlyCostDashboardDto';
import { MonthlyRoutesDashboardDto } from './dtos/MonthlyRouteDashboardDto';
import { KpiCardsDashboardDto } from './dtos/KpiCardsDashboardDto';
import { TopMaintenanceCostDashboardDto } from './dtos/TopMaintenanceCostDashboardDto';
import { ContractedKmAlertDashboardDto } from './dtos/ContractedKmAlertDashboardDto';
import { UpcomingReminderDashboardDto } from './dtos/UpcomingReminderDashboardDto';
import { ImmobilizedVehicleDashboardDto } from './dtos/ImmobilizedVehicleDashboardDto';
import { UpcomingEventDashboardDto } from './dtos/UpcomingEventDashboardDto';
import { TopFuelConsumerDashboardDto } from './dtos/TopFuelConsumerDashboardDto';
import { TopCostPerKmDashboardDto } from './dtos/TopCostPerKmDashboardDto';
import { AssetAboveConsumptionDashboardDto } from './dtos/AssetAboveConsumptionDashboardDto';
import { TopMaintenanceTagDashboardDto } from './dtos/TopMaintenanceTagDashboardDto';
import { PurchasedVehicleKpiDashboardDto } from './dtos/PurchasedVehicleKpiDashboardDto';
import { Co2EmissionsDashboardDto } from './dtos/Co2EmissionsDashboardDto';
import { Co2MonthlyEvolutionDashboardDto } from './dtos/Co2MonthlyEvolutionDashboardDto';
import { EcoDrivingRankingDashboardDto } from './dtos/EcoDrivingRankingDashboardDto';
import { EcoDistributionDashboardDto } from './dtos/EcoDistributionDashboardDto';
import { EcoEvolutionPointDashboardDto } from './dtos/EcoEvolutionPointDashboardDto';
import { VehicleComparisonDashboardDto } from './dtos/VehicleComparisonDashboardDto';
import { FuelExpensesPerAssetDashboardDto } from './dtos/FuelExpensesPerAssetDashboardDto';
import { FuelConsumptionKind, FuelConsumptionPerAssetDashboardDto } from './dtos/FuelConsumptionPerAssetDashboardDto';
import { VehicleFuelKindsDto } from './dtos/VehicleFuelKindsDto';
import { DriverEcoComparisonDashboardDto } from './dtos/DriverEcoComparisonDashboardDto';
import { TopMaintenanceComponentDashboardDto } from './dtos/TopMaintenanceComponentDashboardDto';
import { FleetByFuelDashboardDto } from './dtos/FleetByFuelDashboardDto';
import { FleetDriverAssignmentDashboardDto } from './dtos/FleetDriverAssignmentDashboardDto';
import { FleetByAgencyDashboardDto } from './dtos/FleetByAgencyDashboardDto';
import { FleetBySegmentDashboardDto } from './dtos/FleetBySegmentDashboardDto';
import { TopVehicleCostsDashboardDto } from './dtos/TopVehicleCostDashboardDto';
import { TopDriverCostsDashboardDto } from './dtos/TopDriverCostDashboardDto';
import { MonthlyKmRankingDashboardDto } from './dtos/MonthlyKmRankingDashboardDto';
import { ContractExpiringDashboardDto } from './dtos/ContractExpiringDashboardDto';
import { ContractExpiredDashboardDto } from './dtos/ContractExpiredDashboardDto';
import { ContractDistributionDashboardDto } from './dtos/ContractDistributionDashboardDto';
import { ContractMonthlyEvolutionDashboardDto } from './dtos/ContractMonthlyEvolutionDashboardDto';
import { ScheduledMaintenanceDashboardDto } from './dtos/ScheduledMaintenanceDashboardDto';
import { OverdueMaintenanceDashboardDto } from './dtos/OverdueMaintenanceDashboardDto';
import { MaintenanceCalendarDashboardDto } from './dtos/MaintenanceCalendarDashboardDto';
import { MaintenanceCostEvolutionDashboardDto } from './dtos/MaintenanceCostEvolutionDashboardDto';
import { OperationalKpisDashboardDto } from './dtos/OperationalKpisDashboardDto';
import { UpcomingReservationDashboardDto } from './dtos/UpcomingReservationDashboardDto';
import { TopReservationVehicleDashboardDto } from './dtos/TopReservationVehicleDashboardDto';
import { ExpiredReminderDashboardDto } from './dtos/ExpiredReminderDashboardDto';
import { DriverVehicleHeatmapDashboardDto } from './dtos/DriverVehicleHeatmapDashboardDto';
import { TopAppropriatedVehicleDashboardDto } from './dtos/TopAppropriatedVehicleDashboardDto';
import { DriverLoyaltyDetailDashboardDto } from './dtos/DriverLoyaltyDetailDashboardDto';
import { LocationAlarmDashboardDto } from './dtos/LocationAlarmDashboardDto';
import { CostCenterAggregationDashboardDto } from './dtos/CostCenterAggregationDashboardDto';
import { FuelTankTimelineDashboardDto } from './dtos/FuelTankTimelineDashboardDto';
import { PlafondConsumptionDashboardDto } from './dtos/PlafondConsumptionDashboardDto';

class DashboardService {
	public async get(criteria: DashboardSearchCriteria) {
		const data = await Http.get<DashboardDto>('dashboard', criteria);

		// Fix dates
		if (data) {
			data.consumes?.items.forEach(c => c.items.forEach(cc => (cc.date = new Date(cc.date))));
			data.monthlyCost?.items.forEach(c => c.items.forEach(cc => (cc.date = new Date(cc.date))));
			if (data.monthlyRoute && data.monthlyRoute.items) {
				data.monthlyRoute.items.forEach(cc => (cc.date = new Date(cc.date)));
			}
		}

		return data;
	}

	
	public fixDates(criteria: DashboardSearchCriteria){
		if (criteria.dateFrom) {			
			const year = criteria.dateFrom.getFullYear();
			const month = criteria.dateFrom.getMonth()+1;
			const day = criteria.dateFrom.getDate();
			criteria.dateFrom = new Date(`${year}-${month < 10 ? '0': ''}${month}-${day < 10 ? '0': ''}${day}T00:00:00Z`);			
		}
		if (criteria.dateTo) {
			const year = criteria.dateTo.getFullYear();
			const month = criteria.dateTo.getMonth()+1;
			const day = criteria.dateTo.getDate();
			criteria.dateTo = new Date(`${year}-${month < 10 ? '0': ''}${month}-${day < 10 ? '0': ''}${day}T23:59:59Z`);
		}
		return criteria;
	}

	public async getCounters(criteria: DashboardSearchCriteria) {
		return await Http.get<CountersDashboardDto>('dashboard/counters', this.fixDates(criteria));
	}

	public async getExpenses(criteria: DashboardSearchCriteria) {		
		return await Http.get<ExpensesDashboardDto>('dashboard/expenses', this.fixDates(criteria));
	}

	public async getConsumes(criteria: DashboardSearchCriteria) {
		const data = await Http.get<ConsumesDashboardDto>('dashboard/consumes', this.fixDates(criteria));
		if (data) {
			data.items.forEach(c => c.items.forEach(cc => (cc.date = new Date(cc.date))));
		}
		return data;
	}

	public async getMonthlyCost(criteria: DashboardSearchCriteria) {
		const data = await Http.get<MonthlyCostDashboardDto>('dashboard/monthlycost', this.fixDates(criteria));
		if (data) {
			data.items.forEach(c => c.items.forEach(cc => (cc.date = new Date(cc.date))));
		}
		return data;
	}

	public async getMonthlyRoutes(criteria: DashboardSearchCriteria) {
		const data = await Http.get<MonthlyRoutesDashboardDto>('dashboard/monthlyroutes', this.fixDates(criteria));
		if (data && data.items) {
			data.items.forEach(cc => (cc.date = new Date(cc.date)));
		}
		return data;
	}

	public async getKpiCards(criteria: DashboardSearchCriteria) {
		return await Http.get<KpiCardsDashboardDto>('dashboard/kpicards', this.fixDates(criteria));
	}

	public async getTopMaintenanceCosts(criteria: DashboardSearchCriteria) {
		return await Http.get<TopMaintenanceCostDashboardDto[]>('dashboard/topmaintenance', this.fixDates(criteria));
	}

	public async getContractedKmAlerts(criteria: DashboardSearchCriteria) {
		return await Http.get<ContractedKmAlertDashboardDto[]>('dashboard/contractedkm', this.fixDates(criteria));
	}

	public async getContractedKmProgress(criteria: DashboardSearchCriteria) {
		return await Http.get<ContractedKmAlertDashboardDto[]>('dashboard/contracted-km-progress', this.fixDates(criteria));
	}

	public async getUpcomingReminders(criteria: DashboardSearchCriteria) {
		return await Http.get<UpcomingReminderDashboardDto[]>('dashboard/upcomingreminders', this.fixDates(criteria));
	}

	public async getImmobilizedVehicles(criteria: DashboardSearchCriteria) {
		return await Http.get<ImmobilizedVehicleDashboardDto[]>('dashboard/immobilized', this.fixDates(criteria));
	}

	public async getUpcomingEvents(criteria: DashboardSearchCriteria) {
		return await Http.get<UpcomingEventDashboardDto[]>('dashboard/upcomingevents', this.fixDates(criteria));
	}

	public async getTopFuelConsumers(criteria: DashboardSearchCriteria) {
		const fixed = this.fixDates(criteria);
		// Use repeat format for vehicleIds array (vehicleIds=a&vehicleIds=b) for ASP.NET Core binding
		const queryString = qs.stringify(fixed, { arrayFormat: 'repeat' });
		const data = await Http.get<TopFuelConsumerDashboardDto[]>(`dashboard/topfuel?${queryString}`);
		if (data) {
			data.forEach(d => (d.month = new Date(d.month)));
		}
		return data;
	}

	public async getTopCostPerKm(criteria: DashboardSearchCriteria) {
		return await Http.get<TopCostPerKmDashboardDto[]>('dashboard/topcostperkm', this.fixDates(criteria));
	}

	public async getAssetsAboveConsumption(criteria: DashboardSearchCriteria) {
		return await Http.get<AssetAboveConsumptionDashboardDto[]>('dashboard/assetsaboveconsumption', this.fixDates(criteria));
	}

	public async getTopMaintenanceTags(criteria: DashboardSearchCriteria) {
		return await Http.get<TopMaintenanceTagDashboardDto[]>('dashboard/topmaintenancetags', this.fixDates(criteria));
	}

	public async getPurchasedVehiclesKpi(criteria: DashboardSearchCriteria) {
		return await Http.get<PurchasedVehicleKpiDashboardDto[]>('dashboard/purchasedvehicles', this.fixDates(criteria));
	}

	public async getCo2Emissions(criteria: DashboardSearchCriteria) {
		return await Http.get<Co2EmissionsDashboardDto[]>('dashboard/co2emissions', this.fixDates(criteria));
	}

	public async getCo2MonthlyEvolution(criteria: DashboardSearchCriteria) {
		return await Http.get<Co2MonthlyEvolutionDashboardDto[]>('dashboard/co2monthlyevolution', this.fixDates(criteria));
	}

	public async getEcoDrivingRanking(criteria: DashboardSearchCriteria) {
		return await Http.get<EcoDrivingRankingDashboardDto[]>('dashboard/ecodrivingranking', this.fixDates(criteria));
	}

	// Versão agregada (RGPD-safe) — distribuição da ecocondução da frota, sem identificação por condutor.
	public async getEcoDistribution(criteria: DashboardSearchCriteria) {
		return await Http.get<EcoDistributionDashboardDto>('dashboard/eco-distribution', this.fixDates(criteria));
	}

	// Versão agregada (RGPD-safe) — evolução da penalidade média/km da frota, sem identificação por condutor.
	public async getEcoEvolution(criteria: DashboardSearchCriteria) {
		return await Http.get<EcoEvolutionPointDashboardDto[]>('dashboard/eco-evolution', this.fixDates(criteria));
	}

	public async getTopMaintenanceComponents(criteria: DashboardSearchCriteria) {
		return await Http.get<TopMaintenanceComponentDashboardDto[]>('dashboard/topmaintenancecomponents', this.fixDates(criteria));
	}

	public async getVehicleComparison(vehicleIds: string[], dateFrom?: Date | null, dateTo?: Date | null) {
		return await Http.post<VehicleComparisonDashboardDto[]>('dashboard/vehicle-comparison', {
			vehicleIds,
			dateFrom: dateFrom ? dateFrom.toISOString() : null,
			dateTo: dateTo ? dateTo.toISOString() : null,
		});
	}

	public async getFuelExpensesPerAsset(vehicleIds: string[], dateFrom?: Date | null, dateTo?: Date | null) {
		const data = await Http.post<FuelExpensesPerAssetDashboardDto>('dashboard/fuel-expenses-per-asset', {
			vehicleIds,
			dateFrom: dateFrom ? dateFrom.toISOString() : null,
			dateTo: dateTo ? dateTo.toISOString() : null,
		});
		if (data && data.items) {
			data.items.forEach(v => v.items.forEach(m => (m.date = new Date(m.date))));
		}
		return data;
	}

	public async getFuelConsumptionPerAsset(
		vehicleIds: string[],
		fuelKind: FuelConsumptionKind,
		dateFrom?: Date | null,
		dateTo?: Date | null,
	) {
		const data = await Http.post<FuelConsumptionPerAssetDashboardDto>('dashboard/fuel-consumption-per-asset', {
			vehicleIds,
			dateFrom: dateFrom ? dateFrom.toISOString() : null,
			dateTo: dateTo ? dateTo.toISOString() : null,
			fuelKind: fuelKind === 'electric' ? 1 : 0,
		});
		// Coage decimais: NPoco/JSON.NET serializa decimal? como string em algumas pipelines.
		// Sem isto Victory falha a auto-escalar e os ticks Y aparecem todos a 0.
		if (data && data.items) {
			data.items.forEach(v => {
				v.referenceConsumption = v.referenceConsumption == null ? null : Number(v.referenceConsumption);
				v.items.forEach(m => {
					m.date = new Date(m.date);
					m.value = m.value == null ? null : Number(m.value);
				});
			});
		}
		return data;
	}

	public async getVehicleFuelKinds() {
		return await Http.get<VehicleFuelKindsDto[]>('dashboard/vehicle-fuel-kinds');
	}

	public async getDriverEcoComparison(driverIds: string[], dateFrom?: Date | null, dateTo?: Date | null) {
		return await Http.post<DriverEcoComparisonDashboardDto[]>('dashboard/driver-eco-comparison', {
			driverIds,
			dateFrom: dateFrom ? dateFrom.toISOString() : null,
			dateTo: dateTo ? dateTo.toISOString() : null,
		});
	}

	public async getTopVehicleCosts(criteria: DashboardSearchCriteria) {
		return await Http.get<TopVehicleCostsDashboardDto>('dashboard/top-vehicle-costs', this.fixDates(criteria));
	}

	public async getTopDriverCosts(criteria: DashboardSearchCriteria) {
		return await Http.get<TopDriverCostsDashboardDto>('dashboard/top-driver-costs', this.fixDates(criteria));
	}

	public async getFleetByFuel(criteria: DashboardSearchCriteria) {
		return await Http.get<FleetByFuelDashboardDto>('dashboard/fleet-by-fuel', this.fixDates(criteria));
	}

	public async getFleetDriverAssignment(criteria: DashboardSearchCriteria) {
		return await Http.get<FleetDriverAssignmentDashboardDto>('dashboard/fleet-driver-assignment', this.fixDates(criteria));
	}

	public async getFleetByAgency(criteria: DashboardSearchCriteria) {
		return await Http.get<FleetByAgencyDashboardDto>('dashboard/fleet-by-agency', this.fixDates(criteria));
	}

	public async getFleetBySegment(criteria: DashboardSearchCriteria) {
		return await Http.get<FleetBySegmentDashboardDto>('dashboard/fleet-by-segment', this.fixDates(criteria));
	}

	public async getMonthlyKmRanking(criteria: DashboardSearchCriteria) {
		return await Http.get<MonthlyKmRankingDashboardDto[]>('dashboard/monthly-km-ranking', this.fixDates(criteria));
	}

	public async getContractsExpiring(criteria: DashboardSearchCriteria) {
		return await Http.get<ContractExpiringDashboardDto[]>('dashboard/contracts-expiring', this.fixDates(criteria));
	}

	public async getContractsExpired(criteria: DashboardSearchCriteria) {
		return await Http.get<ContractExpiredDashboardDto[]>('dashboard/contracts-expired', this.fixDates(criteria));
	}

	public async getContractsDistribution(criteria: DashboardSearchCriteria) {
		return await Http.get<ContractDistributionDashboardDto[]>('dashboard/contracts-distribution', this.fixDates(criteria));
	}

	public async getContractsEvolution(criteria: DashboardSearchCriteria) {
		const data = await Http.get<ContractMonthlyEvolutionDashboardDto[]>('dashboard/contracts-evolution', this.fixDates(criteria));
		return data;
	}

	public async getScheduledMaintenances(criteria: DashboardSearchCriteria) {
		return await Http.get<ScheduledMaintenanceDashboardDto[]>('dashboard/scheduled-maintenances', this.fixDates(criteria));
	}

	public async getOverdueMaintenances(criteria: DashboardSearchCriteria) {
		return await Http.get<OverdueMaintenanceDashboardDto[]>('dashboard/overdue-maintenances', this.fixDates(criteria));
	}

	public async getMaintenanceCalendar(criteria: DashboardSearchCriteria) {
		// Bypassa fixDates: dateFrom/dateTo já vêm como Date à meia-noite LOCAL,
		// alinhado com o offset com que advise_maintenance_date/expected_date
		// foram guardadas. fixDates forçava UTC midnight e excluía o dia 1 em fusos > UTC.
		return await Http.get<MaintenanceCalendarDashboardDto[]>('dashboard/maintenance-calendar', criteria);
	}

	public async getMaintenanceCostEvolution(criteria: DashboardSearchCriteria) {
		return await Http.get<MaintenanceCostEvolutionDashboardDto[]>('dashboard/maintenance-cost-evolution', this.fixDates(criteria));
	}

	public async getOperationalKpis(criteria: DashboardSearchCriteria) {
		return await Http.get<OperationalKpisDashboardDto>('dashboard/operationalkpis', this.fixDates(criteria));
	}

	public async getUpcomingReservations(criteria: DashboardSearchCriteria) {
		return await Http.get<UpcomingReservationDashboardDto[]>('dashboard/upcomingreservations', this.fixDates(criteria));
	}

	public async getTopReservationVehicles(criteria: DashboardSearchCriteria) {
		return await Http.get<TopReservationVehicleDashboardDto[]>('dashboard/topreservationvehicles', this.fixDates(criteria));
	}

	public async getExpiredReminders(criteria: DashboardSearchCriteria) {
		return await Http.get<ExpiredReminderDashboardDto[]>('dashboard/expiredreminders', this.fixDates(criteria));
	}

	public async getDriverVehicleHeatmap(criteria: DashboardSearchCriteria) {
		return await Http.get<DriverVehicleHeatmapDashboardDto[]>('dashboard/driverloyalty/heatmap', this.fixDates(criteria));
	}

	public async getTopAppropriatedVehicles(criteria: DashboardSearchCriteria) {
		return await Http.get<TopAppropriatedVehicleDashboardDto[]>('dashboard/driverloyalty/top-appropriated', this.fixDates(criteria));
	}

	public async getDriverLoyaltyDetails(criteria: DashboardSearchCriteria) {
		return await Http.get<DriverLoyaltyDetailDashboardDto[]>('dashboard/driverloyalty/details', this.fixDates(criteria));
	}

	public async getLocationAlarms(criteria: DashboardSearchCriteria) {
		return await Http.get<LocationAlarmDashboardDto[]>('dashboard/location-alarms', this.fixDates(criteria));
	}

	public async getCostCenterExpenses(criteria: DashboardSearchCriteria) {
		return await Http.get<CostCenterAggregationDashboardDto[]>('dashboard/cost-center-expenses', this.fixDates(criteria));
	}

	public async getCostCenterVisits(criteria: DashboardSearchCriteria) {
		return await Http.get<CostCenterAggregationDashboardDto[]>('dashboard/cost-center-visits', this.fixDates(criteria));
	}

	// #66079 — Oscilação de combustível (FMC150): nível do depósito (CAN) + marcadores de abastecimento.
	public async getFuelTankTimeline(criteria: DashboardSearchCriteria) {
		const data = await Http.get<FuelTankTimelineDashboardDto>('dashboard/fuel-tank-timeline', this.fixDates(criteria));
		if (data) {
			// Coage datas e decimais: JSON.NET pode serializar decimal como string em algumas pipelines.
			data.levels?.forEach(l => {
				l.date = new Date(l.date);
				l.level = Number(l.level);
			});
			data.markers?.forEach(m => {
				m.date = new Date(m.date);
				m.chargeDate = m.chargeDate == null ? null : new Date(m.chargeDate);
				m.level = m.level == null ? null : Number(m.level);
				m.observedRise = m.observedRise == null ? null : Number(m.observedRise);
				m.quantity = m.quantity == null ? null : Number(m.quantity);
				m.cost = m.cost == null ? null : Number(m.cost);
			});
		}
		return data;
	}

	// #66600 — Consumo vs plafond. Sem vehicleId na criteria devolve a frota; com vehicleId, só esse ativo.
	public async getPlafondConsumption(criteria: DashboardSearchCriteria) {
		const data = await Http.get<PlafondConsumptionDashboardDto>('dashboard/plafond-consumption', this.fixDates(criteria));
		if (data) {
			// Coage datas e decimais: o JSON.NET pode serializar decimal como string.
			data.items?.forEach(i => {
				i.month = new Date(i.month);
				i.monthlyLimit = Number(i.monthlyLimit);
				i.consumed = Number(i.consumed);
				i.overage = Number(i.overage);
				i.usagePercentage = Number(i.usagePercentage);
			});
		}
		return data;
	}

	// #66600 — o mesmo consumo vs plafond, em Excel.
	public async getPlafondConsumptionReport(criteria: DashboardSearchCriteria) {
		return await Http.getWithConfig<Blob>('dashboard/plafond-consumption-report', this.fixDates(criteria), { responseType: 'blob' });
	}

	public async getLayout() {
		return await Http.get<{ layout: string | null }>('dashboard/layout');
	}

	public async saveLayout(layout: string) {
		return await Http.put<void>('dashboard/layout', { layout });
	}

	// Layout do dashboard por (utilizador, ativo) — usado no detalhe do ativo.
	public async getAssetLayout(vehicleId: string) {
		return await Http.get<{ layout: string | null }>(`dashboard/asset-layout/${vehicleId}`);
	}

	public async saveAssetLayout(vehicleId: string, layout: string) {
		return await Http.put<void>(`dashboard/asset-layout/${vehicleId}`, { layout });
	}

	// Replica a disposição atual (snapshot) para vários ativos do próprio utilizador.
	public async replicateAssetLayout(layout: string, targetVehicleIds: string[]) {
		return await Http.post<void>('dashboard/asset-layout/replicate', { layout, targetVehicleIds });
	}

}

export default new DashboardService();
